import { Reveal } from "@/hooks/useReveal";
import { Phone, Mail } from "lucide-react";

const AGENTS = [
  {
    id: "alfredo",
    name: "Alfredo Manzano",
    role: "Broker / Owner",
    phone: "(661) 212-1300",
    phoneHref: "tel:+16612121300",
    email: "amanzano4reo@gmail.com",
    dre: "01263706",
    photo: "/assets/alfredo.png",
  },
  {
    id: "cristian",
    name: "Cristian Manzano",
    role: "Realtor",
    phone: "(661) 621-8007",
    phoneHref: "tel:+16616218007",
    email: "camanzanore@gmail.com",
    dre: "02241516",
    photo: "/assets/cristian.png",
  },
];

const AgentCard = ({ agent }) => (
  <article
    data-testid={`agent-card-${agent.id}`}
    className="grid grid-cols-12 gap-6 md:gap-10 items-center"
  >
    {/* Portrait */}
    <div className="col-span-5 md:col-span-5">
      <div className="relative p-[3px] bg-[#c0c0c0]/40 inline-block w-full">
        {agent.photo ? (
          <img
            src={agent.photo}
            alt={agent.name}
            className="w-full aspect-[4/5] object-cover block"
          />
        ) : (
          <div className="w-full aspect-[4/5] bg-gradient-to-br from-[#1a1a1a] to-[#2a2a2a] flex items-center justify-center font-heading text-6xl md:text-7xl text-white/30 tracking-wider">
            {agent.name
              .split(" ")
              .map((p) => p[0])
              .join("")}
          </div>
        )}
      </div>
    </div>

    {/* Details */}
    <div className="col-span-7 md:col-span-7">
      <h3 className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tight text-white">
        {agent.name}
      </h3>
      <p className="italic text-white/60 text-base md:text-lg mt-2 mb-8">{agent.role}</p>
      <ul className="space-y-3 text-sm md:text-base text-white/85">
        <li className="flex items-center gap-3">
          <Phone size={14} strokeWidth={1.5} className="text-[#c0c0c0] shrink-0" />
          <a href={agent.phoneHref} className="hover:text-white transition-colors">
            {agent.phone}
          </a>
        </li>
        <li className="flex items-center gap-3 break-all">
          <Mail size={14} strokeWidth={1.5} className="text-[#c0c0c0] shrink-0" />
          <a
            href={`mailto:${agent.email}`}
            className="hover:text-white transition-colors"
          >
            {agent.email}
          </a>
        </li>
        <li className="text-[11px] tracking-[0.28em] uppercase text-white/50 pt-3">
          DRE# {agent.dre}
        </li>
      </ul>
    </div>
  </article>
);

const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative bg-[#1a1a1a] text-white py-28 md:py-40 px-6 md:px-12"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center md:text-left max-w-3xl mb-16 md:mb-24">
          <Reveal>
            <p className="overline mb-6 text-[#c0c0c0]">Our Team</p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
              The people behind
              <em className="italic font-light text-[#e8e8e8]"> Manzano</em>.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 md:gap-20 lg:gap-24">
          {AGENTS.map((a, i) => (
            <Reveal key={a.id} delay={i * 150}>
              <AgentCard agent={a} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
